import { cn, getTierClasses } from './listingCardUtils.js';

const VARIANT_CLASSES = {
  text: 'inline-flex border-transparent bg-transparent p-0 shadow-none',
  chip: 'inline-flex max-w-full items-center rounded-full border px-3 py-1.5 shadow-sm',
  row: 'flex w-full items-center gap-3 rounded-md border border-transparent bg-transparent px-2.5 py-2 shadow-none',
  compact: 'grid w-full gap-3 rounded-lg border bg-white p-3 shadow-sm sm:grid-cols-[auto_minmax(0,1fr)]',
  content: 'grid w-full overflow-hidden rounded-lg border bg-white shadow-sm',
  directory: 'grid w-full overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm',
  hero: 'relative w-full overflow-hidden rounded-lg border bg-slate-950 shadow-sm',
  directoryRow: 'grid w-full gap-4 rounded-lg border bg-white p-4 shadow-sm md:grid-cols-[auto_minmax(0,1fr)_auto]',
};

function getChipShellClasses(tier = 'basic') {
  return {
    basic: 'border-black bg-black hover:bg-white',
    featured: 'border-[color:var(--listing-card-primary,#2563EB)] bg-[color:var(--listing-card-primary,#2563EB)] hover:bg-[color:var(--listing-card-primary-hover,#1D4ED8)]',
    spotlight: 'border-[color:var(--listing-card-primary,#2563EB)] bg-[color:var(--listing-card-primary,#2563EB)] hover:bg-[color:var(--listing-card-primary-hover,#1D4ED8)]',
  }[tier] || 'border-black bg-black hover:bg-white';
}

export default function ListingCardShell({
  children,
  variant = 'content',
  tier = 'basic',
  density = 'comfortable',
  selected = false,
  disabled = false,
  onClick,
  className,
}) {
  const tierClasses = getTierClasses(tier);
  const interactive = Boolean(onClick) && !disabled;
  const Component = interactive ? 'button' : 'article';
  const chipShellClasses = variant === 'chip' ? getChipShellClasses(tier) : '';

  return (
    <Component
      type={interactive ? 'button' : undefined}
      onClick={interactive ? onClick : undefined}
      disabled={interactive ? disabled : undefined}
      aria-disabled={disabled || undefined}
      data-listing-card-variant={variant}
      data-listing-card-tier={tier}
      className={cn(
        'listing-card-foundation text-left transition',
        VARIANT_CLASSES[variant] || VARIANT_CLASSES.content,
        variant === 'chip' ? 'group/listing-chip' : '',
        variant === 'chip' ? chipShellClasses : '',
        variant !== 'chip' && variant !== 'row' && variant !== 'directory' ? tierClasses.border : '',
        density === 'compact' && variant !== 'text' && variant !== 'chip' && variant !== 'row' ? 'gap-2 p-3' : '',
        interactive && variant === 'row' ? 'cursor-pointer hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary' : '',
        interactive && variant !== 'row' ? 'cursor-pointer hover:-translate-y-0.5 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary' : '',
        selected ? 'ring-2 ring-primary ring-offset-2' : '',
        disabled ? 'pointer-events-none opacity-55' : '',
        className,
      )}
    >
      {children}
    </Component>
  );
}
